// @ts-nocheck
/* eslint-disable */
import { ZeePlayerConfig } from './configs/ZeePlayerConfig';
import {
  getCookieData,
  getLocalStorage,
  setLocalStorage,
  getBrowserType,
  getLanguageName,
  getLocalStorageInteger,
  toggleKeyMoments,
  getSessionStorage,
  setSessionStorage,
  fetchSelfErrors,
  isMobileDevice,
  mergeObjects,
  isIpadChrome,
  toggleFreeMinutes,
  getStoredProfile,
  isSportsLiveEvent,
  isB2BPartner,
  isLiveFIFAEvent
} from './utils/Utils';
import { MediaPlayer } from './MediaPlayer';
import { PlayerConfig } from './configs/PlayerConfig';
import { Media, Medium } from './configs/Media';
import { Events } from './events/Events';
import { DRMConfig } from './configs/DRMConfig';
import { KeySystem } from './drm/KeySystem';
import { adCuePoints } from './components/AdCuePoints';
import { TapToUnmute } from './components/TapToUnmute';
import {
  checkAdsAvailability,
  checkIfAdsUrlPresent,
  getDAICustomParameters
} from './utils/AdHelper';
import {
  SpApiResponse,
  AssetDetails,
  SubtitleURL
} from './configs/SpApiResponse';
import { TextTrack, TextTrackKind } from './configs/TextTrack';
import {
  onPlayEventHelper,
  onPlayEndedEventHelper,
  fullScreenEvent,
  registerEvents,
  playerProgress,
  triggerWatchHistory,
  onErrorHelper,
  subtitleChange,
  triggerRecoSkipButton,
  onTimeUpdateEventHelper,
  getActiveSubtitles,
  onPauseEventHelper,
  onSeekSrubEventHelper,
  audioChange,
  videoQualityChange,
  showIsTrailer,
  convivaSessionOnReady,
  convivaSessionKeyMomentsOnReady,
  reportVideoViewEvent,
  ifAssetIdChanges,
  onVolumeChange,
  onmuteChange,
  handleStaleApiCall,
  toggleSubscribeTeaserBanner,
  subscriptionNudgeOnPlayerPopup,
  removeSubscriptionNudgeOnPlayer,
  updateUpnextState,
  createLanguageSelectionUnit,
  createLanguageSelectionPills,
  updateFreeMinutes,
  getFreeMinutes,
  setFreeMinutes,
  SOShandler,
  resetPlayerEventsHelperValuesOnDispose,
  getFormattedErrorCode,
  showTobaccoAdvisoryPreRollVideo,
  checkIfTobaccoAdvisory,
  displayScoreCard,
  detectChromeCast,
  addLanguageLogo,
  modifyLanguageChangeMenu,
  updateLanguageLogo,
  setDefaultAudioTrack,
  selectDefaultAudioLanguage
  // handlePinScoreCardMixpanel,
  // intervalTimerRefForPinScoreCard
} from './utils/playerEventsHelper';
import { initGatingTimer } from './utils/playerEventsHelper';
import {
  seekReceiverWithSeekedSender,
  setReceiverVolume,
  textTracksChange
} from './cast/CastHelper';
import { constants } from './constants/playerConstants';
import { AdEvents } from './events/AdEvents';
import { MimeType } from './configs/MimeTypes';
import { ConvivaAnalyticsTracker } from './analytics/ConvivaAnalyticsTracker';
import { KeyMomentsConvivaAnalyticsTracker } from './analytics/KeyMomentsConvivaAnalyticsTracker';
import { showContentDescriptor } from './components/ContentDescriptor';
import { addGoLiveButton } from './components/GoLiveButton';
import { ErrorCode } from '../src/error/Error';
import { AnalyticsManager } from './analytics/AnalyticsManager';
import { playerEventsConstants } from './constants/playerConstants';
import { AdClient, AdConfig } from './configs/AdConfig';
import { addUserWaterMark, addWaterMark, fetchConcurrentUsers } from './components/WaterMark';
import { FeatureFlagConstant } from './utils/FeatureFlagConstants';
import npawAnaltics from './analytics/npaw/npawAnalytics';
import { getRendition, getSubtitles } from './analytics/npaw/npawHelper';
import {
  NPAW_CUSTOM_CONSTANTS,
  VIDEO_OPTIONS_KEYS
} from './analytics/npaw/npawConstants';

let convivaAnalyticsTracker: any;
declare global {
  interface Window {
    avodNudgeHandler: any;
    translationsAndConfigs: any;
    parentalPinPopUpEnabled: boolean;
    chromePopupDisplayed: any;
    drmSessionError: boolean;
    convivaSDK: any;
    videoPlayer: any;
    parentalPinIncorrect: boolean;
    Conviva: any;
    convivaAnalytic: any;
    analyticsManager: any;
    is_dai: boolean;
    isLive: boolean;
    isConvivaSessionRequired: boolean;
    appVersion: String;
    autoSeek: boolean;
    contentExit: any;
    adsLoader: any;
    playerAnalyticsObject: any;
    convivaAdAnalytics: any;
    isConvivaAdSessionRequired: boolean;
    mixpanel: any;
    VmaxVideoJSPlugin: any;
    VMAXSDK: any;
    isSportsLive: boolean;
    keyMomentsconvivaAnalytic: any;
    playerSeconds: number;
    playerReloadTimer: any;
    clearPlayerReloadTimer: any;
    enableReloadPlayerOnTimeout: boolean;
    showErrorMessageOnLicenseFails: any;
    isClearMedia: any;
    triggerFallbackPlayback: any;
    videojs: any;
    isPlayingEventSent: boolean;
  }
}

export default class ZeeVideoJSPlayer {
  keySystem = new KeySystem();
  playerConfig: ZeePlayerConfig;
  videoPlayer: any;
  playableData: AssetDetails = null;
  isPlayerEventRegistered: boolean;
  singlePlayDetails: SpApiResponse;
  similarFromReco: any;
  translationsAndConfigs: any;
  isDai: boolean;
  preRollForDaiConfig: boolean;
  licenseCertHeaders: Map<string, string>;
  contentWithNoTrailer: boolean;
  isRecoPending: boolean;
  playerDisposedFlag = true;
  contentDescriptorHidden: boolean;
  isNewsCatchup: boolean;
  isAdPlaying = false;
  mixpanelData: any;
  isPlayingClearContent = false;
  metaDataLoaded = false;
  displayLanguage: string;
  analyticsManager: AnalyticsManager;
  mandatoryVideoCountUpdated: boolean;
  preRollDetectedorFailed: boolean;
  isVisible = true;
  mediaObject: Media;
  setPlayerHaltedFlag: boolean;
  defaultPlayerConfig: any;
  isStaleApisCalled: boolean;
  validContentTypesForStaleApi: string[];
  firstPlay = false;
  prevCapping = null;
  concurrentUsersTimer: any;
  isPopUpVideo: boolean = false;
  isSportsLive: boolean = false;
  sosAssetType: any;
  sosAssetSubtype: any;
  sosCapping: any;
  freeMinutesTimer: any;
  showFreeMinutesTimer: boolean;
  freeAvailableSeconds: number = 900;
  initGatingTimer: boolean;
  hasTobaccoAdvisoryVideo: boolean = false;
  preRollTobaccoAdvisoryVideoShown: boolean = false;
  showTobaccoAdvisoryWithoutPreRoll: boolean = false;
  // retry logic for player timout
  playerReloadTimer: any;
  incrementPlayerCounter: any;
  videoPlayed = false;
  reloadCount = 0;
  // retry logic
  isSOSEnabled = false;
  entitledLanguages: any;
  languageLogoPayload: any;
  isPlayerLogoEnabled: boolean = false;
  npawAccountCode: string = '';
  longWatchRemainingTime: number = 0;
  longWatchStartTime: number = 0;
  isLongWatchEventSent: boolean = false;
  triggerGA4timeout: any;
  hasAdError: boolean = false;

  constructor(config: ZeePlayerConfig) {
    this.playerConfig = config;
    this.videoPlayer;
    this.isPlayerEventRegistered = false;
    this.setDataFromPlayerConfig();
    this.contentWithNoTrailer = false;
    this.isRecoPending = true;
    this.similarFromReco = [];
    this.contentDescriptorHidden = true;
    this.isNewsCatchup = false;
    this.preRollForDaiConfig = false;
    this.analyticsManager = AnalyticsManager.getInstance();
    this.mandatoryVideoCountUpdated = false;
    this.preRollDetectedorFailed = false;
    this.isStaleApisCalled = false;
    this.validContentTypesForStaleApi = ['video', 'episode'];
    this.sosAssetType = null;
    this.sosAssetSubtype = null;
    this.sosCapping = null;
    this.showFreeMinutesTimer = false;
    this.initGatingTimer = false;
    this.longWatchRemainingTime = constants.userLongWatchGA4Trigger;
    this.isLongWatchEventSent = false;
    if (this.playerConfig.videoTagId === 'video-tag-popup') {
      this.isPopUpVideo = true;
      convivaAnalyticsTracker = new KeyMomentsConvivaAnalyticsTracker();
      window.convivaAnalytic?.reportEvent(
        window.Conviva?.Constants.Events.USER_WAIT_STARTED || ''
      );
    } else {
      convivaAnalyticsTracker = new ConvivaAnalyticsTracker();
    }
    document.addEventListener(
      'visibilitychange',
      this.handleVisibilityChange.bind(this),
      false
    );
    this.freeMinutesTimer = null;
  }

  // Same as load media token function
  setDataFromPlayerConfig(): void {
    this.playerConfig = { ...this.playerConfig };
    this.singlePlayDetails = this.playerConfig.singlePlayDetails;
    this.mixpanelData = this.playerConfig.mixpanelData || {};
    this.displayLanguage = this.playerConfig.displayLanguage;
    this.npawAccountCode = this.playerConfig.npawAccountCode;
    // Initialize NPAW with the correct environment
    if (this.npawAccountCode) {
      npawAnaltics.initialize(this.npawAccountCode);
    }
    this.analyticsManager?.setMixpanelPlayerConfig(this.playerConfig);
  }

  getPlayableData(): any {
    const {
      entitlement,
      keyOsDetails,
      assetDetails,
      trailerDetails,
      error_code,
      error_msg = ''
    } = this.singlePlayDetails || {};
    const {
      isIncognitoOn: isIncognitoMode = false,
      toggleWatchTrailerButton = null
    } = this.playerConfig || {};
    const { isPremiumPlayback: isPremiumContent = false } = entitlement || {};
    const {
      is_drm: isDRMPlayback,
      content_gating,
      content_gating_live,
      asset_subtype
    } = assetDetails || {};
    const isTelcoUser = getLocalStorage('isTelcoUser');
    const partnerName =
      getCookieData('partner') || getLocalStorage('partnerName');

    const profilesConfig = this.playerConfig.getFeatureFlagConfig(
      FeatureFlagConstant.CONFIG_PROFILES
    );

    const { enabled, payload } = this.playerConfig.getFeatureFlagConfig(
      FeatureFlagConstant.FEATURE_GATING
    );
    const { enable_popup_sports_vod = false } = payload;
    const isSportsVodContentGatingEnabled = enabled && enable_popup_sports_vod;

    const profilesEnabled = profilesConfig?.enabled ?? false;
    const toggle_kids_feature = profilesConfig?.payload?.toggle_kids_feature;
    const kids_player_error_msg =
      profilesConfig?.payload?.kids_player_error_msg;

    // telco
    if (
      isIncognitoMode &&
      isPremiumContent &&
      isDRMPlayback &&
      !isTelcoUser &&
      !partnerName
    ) {
      // should create and handle the below function for telco partner - new to be implemneted some error msg
      // ztvlib.eventmanager.incognitoPremiumPlaybackMessage();
      return null;
    }
    // normal content
    else if (entitlement && keyOsDetails) {
      const {
        isAVOD,
        isPremiumPlayback,
        isTrailer,
        isLive,
        is_dai = 0
      } = entitlement;
      this.isDai = is_dai ? true : false;

      const isKidsProfile = getStoredProfile()?.profileType === 0;
      if (
        profilesEnabled &&
        toggle_kids_feature &&
        isKidsProfile &&
        !assetDetails?.kids_safe
      ) {
        const error_msg = kids_player_error_msg;
        this.playerConfig.triggerPopUp({
          name: 'singleMessagePopup',
          error_code,
          error_msg
        });
        return null;
      }

      if (
        ((isAVOD && !isTrailer) || isPremiumPlayback) &&
        ((assetDetails.is_drm && keyOsDetails.sdrm) ||
          (!assetDetails.is_drm && keyOsDetails.hls_token))
      ) {
        // currently isTrailer is 0 for trailer contents so handled with asset_subtype.
        if (
          assetDetails.asset_subtype === 'trailer' &&
          toggleWatchTrailerButton
        ) {
          toggleWatchTrailerButton({ disable: true });
        } else if (toggleWatchTrailerButton) {
          toggleWatchTrailerButton({ disable: false });
        }
        return assetDetails;
      } else if (isTrailer && keyOsDetails.sdrm && toggleWatchTrailerButton) {
        toggleWatchTrailerButton({ disable: true });
        return trailerDetails;
      } else if (isLive && keyOsDetails.video_token) {
        return assetDetails;
      }
    }
    // spapi error handling before playback
    else if (
      error_code === '3608' ||
      error_code === '606' ||
      error_code === '610' ||
      error_code === '607' ||
      error_code === '3804' ||
      error_code === '3612' ||
      error_code === '601' ||
      error_code === '603' ||
      error_code === '3609' ||
      error_code === '3610' ||
      error_code === '3814' ||
      error_code === '3805' ||
      (error_code && error_code.toString()) == '3603' ||
      error_code === '3614'
    ) {
      if (error_code === '3614') {
        this.playerConfig.triggerPopUp({
          name: 'singleMessagePopup',
          error_code,
          error_msg
        });
        return null;
      }
      if (
        this.playerConfig.callStaledApis &&
        this.validContentTypesForStaleApi.includes(
          this.playerConfig.contentType
        )
      ) {
        this.playerConfig.callStaledApis();
      }
      if (error_code === '3814' || error_code === '3612') {
        this.playerConfig.triggerPopUp({ name: 'svodOrTvod' });
        this.playerConfig.triggerTeaserBanner(this.playerConfig);
        return assetDetails;
      }
      if (error_code === '3805') {
        this.playerConfig.triggerPopUp({
          name: 'singleMessagePopup',
          error_code,
          error_msg
        });
        return assetDetails;
      }
      return assetDetails;
    }
    // if user is not registered & there is no trailer, we have nothing to play
    else if (
      !this.contentWithNoTrailer &&
      error_code === '604' &&
      this.playerConfig.tvodState &&
      window &&
      window.translationsAndConfigs
    ) {
      this.contentWithNoTrailer = true;
      this.playerConfig.triggerPopUp({ name: 'svodOrTvod' });
      this.playerConfig.triggerTeaserBanner(this.playerConfig);
    }
    return null;
  }

  // playback flow function start here ******
  initPlaybackFlow() {
    const {
      error_code = '',
      error_msg = '',
      entitlement,
      parentalControlPin = ''
    }: any = this.singlePlayDetails || {};
    const { isTrailer, isAdAuthenticated } = entitlement || {};
    const { payload: tobaccoAdvisoryConfig } =
      this.playerConfig.getFeatureFlagConfig(
        FeatureFlagConstant.CONFIG_TOBACCO
      ) || {};

    let containsHealthspot = false;
    if (
      this.singlePlayDetails?.tobaccoAdvisoryDetails?.video_segments &&
      tobaccoAdvisoryConfig?.video_segment_config?.enable
    ) {
      this.hasTobaccoAdvisoryVideo = true;
    }
    if (checkIfTobaccoAdvisory(this.singlePlayDetails, tobaccoAdvisoryConfig)) {
      containsHealthspot = true;
    }
    convivaAnalyticsTracker.updateConvivaInfo({
      containsHealthspot: containsHealthspot
    });
    const {
      tvodObj = null,
      adultPopupComponent,
      userType = 'guest'
    } = this.playerConfig || {};
    if (
      error_code &&
      (error_code === '3804' || // subscription error
        error_code === '3612' ||
        error_code === '604') // tvod scubscription error with no trailer
    ) {
      if (!this.isPlayerEventRegistered) {
        // passing reference of player object
        registerEvents(this, this.isPopUpVideo);
      }
      if (error_code === '3804' || error_code === '3612') {
        // getting error code 3804 for content with no trailer
        // window.ztvlib.makeShdCall = (a, b) => makeShdCallPlayer(a, b); // handling this case for shd call PWA2-12072
        this.playerConfig.triggerPopUp({ name: 'svodOrTvod' });
        this.playerConfig.triggerTeaserBanner(this.playerConfig);
      }
      if (error_code === '604' && tvodObj) {
        this.similarFromReco = [];
        this.playerConfig.triggerPopUp({ name: 'svodOrTvod' });
      }
    } else if (
      (isAdAuthenticated && !isTrailer) ||
      (error_code && (error_code === '601' || error_code === '603'))
    ) {
      this.playerConfig.triggerPopUp({
        name: 'adultPopup',
        isAdvertisementAuthenticated: false
      });
    } else if (
      (error_code && error_code.toString()) == '3603' ||
      error_code === '610' ||
      error_code === '607' ||
      error_code === '3609' ||
      error_code === '3610' ||
      error_code === '3805'
    ) {
      this.playerConfig.triggerPopUp({
        name: 'singleMessagePopup',
        error_code,
        error_msg
      });
    } else if (error_code === '606') {
      window.parentalPinPopUpEnabled = true;
      convivaAnalyticsTracker.createConvivaSessionParental(this);
      if (userType === 'guest') {
        this.playerConfig.triggerPopUp({
          name: 'adultPopup',
          isAdvertisementAuthenticated: false
        });
      } else if (parentalControlPin || parentalControlPin === 0) {
        this.playerConfig.triggerPopUp({ name: 'parentalPopup' });
      } else {
        this.playerConfig.handleParentalPin();
      }
      registerEvents(this, this.isPopUpVideo);
    } else {
      this.initializePlaybackType();
    }
  }

  // differentiates the playback types and handles the plyback flow
  initializePlaybackType() {
    this.setLicenseCertHeaders();
    let protectedMedia = this.getProtectedMedia();
    if (protectedMedia) {
      this.isPlayingClearContent = false;
      this.initMediaPlayer(protectedMedia);
    } else {
      this.initializeFallbackPlayback();
    }
  }

  // Get the non protected media configurations
  getClearMedia(): Media {
    let media: Media = {
      title: '',
      type: MimeType.APPLICATION_M3U8,
      medium: Medium.VIDEO,
      poster: this.playerConfig.posterImage
    };
    if (
      this.singlePlayDetails.keyOsDetails &&
      this.singlePlayDetails.keyOsDetails.hls_token
    ) {
      media.src = this.singlePlayDetails.keyOsDetails.hls_token;
    } else if (
      this.singlePlayDetails.keyOsDetails &&
      this.singlePlayDetails.keyOsDetails.video_token
    ) {
      if (
        this.playerConfig.startTime &&
        this.playerConfig.endTime &&
        window.location.href.includes('start') &&
        window.location.href.includes('end')
      ) {
        this.isNewsCatchup = true;
        media.src = `${this.singlePlayDetails.keyOsDetails.video_token}&start=${this.playerConfig.startTime}&end=${this.playerConfig.endTime}`;
      } else {
        this.isNewsCatchup = false;
        media.src = this.singlePlayDetails.keyOsDetails.video_token;
      }
    }
    return media.src ? media : null;
  }

  // Get the protected media configurations
  getProtectedMedia(): Media | null {
    //TODO: REMOVE LATER
    if (this.singlePlayDetails && this.singlePlayDetails.timeStamp) {
      const timeStamp = this.singlePlayDetails.timeStamp;
      const timeDiff = Math.floor((new Date() - timeStamp) / 1000) / 60;
      if (timeDiff >= 2) {
        let eventPayload = {
          type: 'SINGLE_PLAY_TIME_STAMP_EXPIRED'
        };
        this.sendConvivaReportEvent(eventPayload);
      }
    }
    const { entitlement, keyOsDetails } = this.singlePlayDetails || {};
    let dashStreamURL = '';
    let hlsStreamURL = '';

    if (keyOsDetails && keyOsDetails.nl && keyOsDetails.sdrm) {
      const browserType = getBrowserType();
      if (
        this.playableData.video_url &&
        (this.playableData.video_url['mpd'] ||
          this.playableData.video_url['m3u8'])
      ) {
        dashStreamURL = this.playableData.video_url['mpd'];
        hlsStreamURL = this.playableData.video_url['m3u8'];
        return browserType === 'Safari'
          ? this.getFairplayConfig(hlsStreamURL)
          : this.getWidevineConfig(dashStreamURL);
      } else {
        // handle when video_url is not present
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }

    return null;
  }

  // code will return widevine DRM configurations
  getWidevineConfig(streamURL: string): Media {
    const widevineConfig: DRMConfig = {
      drm: KeySystem.WIDEVINE,
      licenseUri: this.playerConfig.licenseUrl + constants.widevineLicenseUri,
      certificateUri:
        this.playerConfig.licenseUrl + constants.widevineLicenseUri,
      licenseHeaders: this.licenseCertHeaders,
      certificateHeaders: this.licenseCertHeaders
    };
    return {
      title: '',
      src: streamURL,
      type: MimeType.APPLICATION_MPD,
      medium: Medium.VIDEO,
      poster: this.playerConfig.posterImage,
      keySystems: this.keySystem.getConfigs(widevineConfig)
    };
  }

  getMimeType() {
    const mimeTypeCheckEnabledFromConfig = this.playerConfig.isFeatureEnabled(
      FeatureFlagConstant.FEATURE_MIMETYPE_CHECK_ENABLED
    );

    return isIpadChrome() && mimeTypeCheckEnabledFromConfig
      ? MimeType.APPLICATION_MP4
      : MimeType.APPLICATION_M3U8;
  }
  // code will return FairPlay DRM configurations
  getFairplayConfig(streamURL: string): Media {
    const fairPlayConfig: DRMConfig = {
      drm: KeySystem.FAIRPLAY,
      certificateUri: constants.fairPlayCertificateUri,
      licenseUri: this.playerConfig.licenseUrl + constants.fairPlayLicenseUri,
      licenseHeaders: this.licenseCertHeaders
    };
    return {
      title: '',
      src: streamURL,
      type: this.getMimeType(),
      medium: Medium.VIDEO,
      poster: this.playerConfig.posterImage,
      keySystems: this.keySystem.getConfigs(fairPlayConfig)
    };
  }

  setLicenseCertHeaders(): void {
    this.licenseCertHeaders = new Map();
    this.licenseCertHeaders.set('nl', this.playerConfig.nl);
    this.licenseCertHeaders.set('customdata', this.playerConfig.customdata);
  }

  initMediaPlayer(media: Media) {
    const { getPosterUrl, isRequestedByBot, userData } = this.playerConfig;
    if (
      media &&
      !this.isNewsCatchup &&
      this.singlePlayDetails &&
      (this.isDai || this.singlePlayDetails.adDetails) &&
      !isRequestedByBot
    ) {
      media.advertising = this.getAdconfig();
    } else if (this.hasTobaccoAdvisoryVideo) {
      this.showTobaccoAdvisoryWithoutPreRoll = true;
    }
    let eventPayload = {
      type: 'MEDIA_SOURCE_LATEST',
      payload: JSON.stringify(media)
    };
    this.entitledLanguages =
      this.singlePlayDetails?.assetDetails?.entitled_languages || [];
    this.sendConvivaReportEvent(eventPayload);

    const defaultConfig: PlayerConfig = {
      media: media,
      autoplay: !isRequestedByBot, // disable autoplay when requested by Bot
      muted:
        (this.videoPlayer &&
          this.videoPlayer.player &&
          this.videoPlayer.player() &&
          this.videoPlayer.getMutedState()) ||
        false,
      loop: false,
      controls: !isRequestedByBot, // disable controls when requested by Bot
      errorDisplay: false,
      // add poster image for bot as autoplay is disabled
      poster: isRequestedByBot
        ? getPosterUrl({
          tagName: 'playerPoster',
          item: this.singlePlayDetails.assetDetails
        })
        : '',
      logo: '',
      sportsLive: this.isSportsLive,
      liveui: this.isSportsLive ? true : false
    };
    let mergedPlayerConfig = { ...defaultConfig };
    if (this.playerConfig.getFeatureFlagConfig) {
      let playerConfiguarionFromOffers = {};
      if (isMobileDevice()) {
        const { enabled, payload } = this.playerConfig.getFeatureFlagConfig(
          FeatureFlagConstant.CONFIG_PLAYER_OPTIONS_MOBILE
        );
        playerConfiguarionFromOffers = enabled ? payload : {};
      }
      const { enabled, payload } = this.playerConfig.getFeatureFlagConfig(
        FeatureFlagConstant.CONFIG_PLAYER_OPTIONS_DESKTOP
      );
      playerConfiguarionFromOffers = enabled ? payload : {};
      mergedPlayerConfig = mergeObjects(
        defaultConfig,
        playerConfiguarionFromOffers
      );
    }
    // Removed unnecessary code from here
    if (this.playerDisposedFlag) {
      this.playerDisposedFlag = false;
      try {
        this.videoPlayer = new MediaPlayer(this.playerConfig.videoTagId);
      } catch (error) {
        console.log('media player failed to load', error);
      }
    }
    this.videoPlayer.destroy();

    if (this.isDai) {
      media = {
        ...media,
        cust_params: getDAICustomParameters(
          this.mixpanelData,
          this.playerConfig,
          this.singlePlayDetails
        )
      };
      defaultConfig.media = media;
    }
    if (this.isVisible) {
      this.videoPlayer.setup(
        mergedPlayerConfig,
        media,
        this.singlePlayDetails,
        userData,
        this.mixpanelData,
        isRequestedByBot
      );
      // this.videoPlayer.setSource(media);
    } else {
      this.mediaObject = media;
      this.defaultPlayerConfig = mergedPlayerConfig;
      this.setPlayerHaltedFlag = true;
    }
    this.eventHandler(this.videoPlayer);
  }

  initializeFallbackPlayback() {
    let clearMedia = this.getClearMedia();
    this.isPlayingClearContent = true;
    this.initMediaPlayer(clearMedia);
  }

  // playback flow function end here *******

  // code will generate the AD configurations based on condition
  getAdconfig(): Adconfig {
    const { entitlement } = this.singlePlayDetails || {};
    const { isLive } = entitlement;
    let vmaxAds = this.getVmaxAdConfigurations();
    if (vmaxAds) {
      return vmaxAds;
    } else {
      if (isLive) {
        const isPreRollAvailable = checkAdsAvailability(this.singlePlayDetails);
        if (isPreRollAvailable && !this.preRollForDaiConfig) {
          this.preRollForDaiConfig = true;
          return this.getGoogleIMAConfigurations();
        } else {
          if (this.isDai && this.singlePlayDetails.keyOsDetails) {
            return this.getGoogleDaiConfigurations();
          }
        }
      } else {
        return this.getGoogleIMAConfigurations();
      }
    }
  }

  // Code will generate Vmax configurations
  getVmaxAdConfigurations(): Adconfig {
    const {
      adDetails: {
        adPriority: { VMAX = 0, DFP = 0 } = {},
        VMAX: adDetailsVmax = {}
      } = {}
    } = this.singlePlayDetails || {};
    if (VMAX === 1 && DFP === 2 && adDetailsVmax) {
      return {
        client: AdClient.VMAX,
        vmaxSettings: { ads: adDetailsVmax }
      };
    }
    return false;
  }

  // Code will generate Google IMA configurations
  getGoogleIMAConfigurations(): Adconfig {
    let adResponse = checkAdsAvailability(this.singlePlayDetails);
    let isAdsUrlPresent = checkIfAdsUrlPresent(this.singlePlayDetails);
    const { payload: imaSettingsFromS3 } =
      this.playerConfig?.getFeatureFlagConfig(
        FeatureFlagConstant.CONFIG_GOOGLE_IMA
      );
    if (adResponse && !isAdsUrlPresent) {
      return {
        client: AdClient.IMA,
        imaSettings: {
          adTagUrl: '',
          adResponse: adResponse,
          imaSettingsFromS3: imaSettingsFromS3 ? imaSettingsFromS3 : {}
        }
      };
    } else if (adResponse && isAdsUrlPresent) {
      return {
        client: AdClient.IMA,
        imaSettings: {
          adTagUrl: adResponse,
          adResponse: '',
          imaSettingsFromS3: imaSettingsFromS3 ? imaSettingsFromS3 : {}
        }
      };
    }
  }

  // Code will generate DAI configurations
  getGoogleDaiConfigurations(): AdConfig {
    const tempDisable = true;
    const keyOsDetails = this.singlePlayDetails.keyOsDetails;
    const authToken =
      this.singlePlayDetails.daiDetails &&
        this.singlePlayDetails.daiDetails.auth_token
        ? this.singlePlayDetails.daiDetails.auth_token
        : '';
    let assetKey = '';
    // get the DRM protected asset key if the content is DRM protected
    if (keyOsDetails.nl && keyOsDetails.sdrm && !tempDisable) {
      let browserType = getBrowserType();
      if (browserType === 'Safari') {
        if (
          keyOsDetails.hls_drm_asset_key &&
          keyOsDetails.hls_drm_asset_key != ''
        )
          assetKey = keyOsDetails.hls_drm_asset_key;
      } else {
        if (
          keyOsDetails.dash_drm_asset_key &&
          keyOsDetails.dash_drm_asset_key != ''
        )
          assetKey = keyOsDetails.dash_drm_asset_key;
      }
    } else if (keyOsDetails.asset_key) {
      assetKey = keyOsDetails.asset_key;
    } else {
      return null;
    }

    return {
      client: AdClient.DAI,
      daiSettings: {
        contentSourceId: '',
        assetKey: assetKey,
        isLiveStream: true,
        videoId: '',
        authToken: authToken
      }
    };
  }

  generateSubtitleTracks(subs: SubtitleURL[], activeLanguageTrack: String) {
    var tracks: TextTrack[] = [];
    const { audioLanguageMapper } = this.playerConfig;
    let languageMatch = '';
    if (getBrowserType() !== 'Safari') {
      let subtitlePreference: { [key: string]: string } | null = null;
      const storedSubtitlePreference =
        localStorage.getItem('subtitlePreference');
      if (storedSubtitlePreference !== null) {
        // Check if the value exists in localStorage
        try {
          subtitlePreference = JSON.parse(storedSubtitlePreference);
          if (subtitlePreference && subtitlePreference[activeLanguageTrack]) {
            languageMatch = subtitlePreference[activeLanguageTrack];
          }
        } catch (error) {
          console.error('Error parsing subtitlePreference:', error); // Handle parsing error
        }
      }
    } else {
      languageMatch = sessionStorage.getItem('subtitleName') || '';
    }
    if (subs.length > 0) {
      subs.forEach((sub) => {
        let track: TextTrack = {};
        track.kind = TextTrackKind.subtitle;
        track.src = sub.url;
        // apply when subtitle is not safari

        if (languageMatch && languageMatch === sub.language) {
          track.mode = 'showing';
        }
        track.label =
          audioLanguageMapper[sub.language.toLowerCase()] ||
          getLanguageName(sub.language) ||
          sub.language;
        track.srclang = sub.language;
        tracks.push(track);
      });
    }
    return tracks;
  }

  eventHandler(videoPlayer): void {
    let isEntitledLanguageFeatureEnabled = false;
    let supportForOlderContents = [];
    if (this.playerConfig?.getFeatureFlagConfig) {
      const { enabled, payload } = this.playerConfig.getFeatureFlagConfig(
        FeatureFlagConstant.CONFIG_PLAYER_ENTITLED_LANGUAGES
      );
      // Temporary workaround for older content where the MPD language gives wrong value like rani rashmoni.
      supportForOlderContents = payload?.supportForOlderContents || [];
      isEntitledLanguageFeatureEnabled = enabled;
    }
    registerEvents(this, this.isPopUpVideo);
    if (!this.isPlayerEventRegistered) {
      this.isPlayerEventRegistered = true;
      // passing reference of player object
      //adCuePoints
      let that = this;
      let timeUpdateConviFlag = true;

      const handleEntitledLangError = (videoPlayer) => {
        console.log('Entitlement Language Error!!');
        videoPlayer && videoPlayer.pause();
        const multiAudioConfig = this.playerConfig?.getFeatureFlagConfig(
          FeatureFlagConstant.MULTI_AUDIO
        );
        const multiAudioSelectionEnabled = multiAudioConfig?.enabled ?? false;
        if (multiAudioSelectionEnabled) {
          this.playerConfig?.showUpgradeSubscriptionPopup();
        } else {
          if (this?.singlePlayDetails?.assetDetails?.dubbed_error) {
            let error_code =
              this.singlePlayDetails?.assetDetails?.dubbed_error?.error_code;
            let error_msg =
              this.singlePlayDetails?.assetDetails?.dubbed_error?.error_message;
            this.playerConfig.triggerPopUp({
              name: 'singleMessagePopup',
              error_code,
              error_msg
            });
            return;
          }
        }
      };
      this.videoPlayer.on(
        Events.ENTITLED_LANG_ERROR,
        handleEntitledLangError.bind(this)
      );

      this.videoPlayer.on(Events.USER_ACTIVE, function () {
        isMobileDevice() && toggleFreeMinutes(false);
      });

      this.videoPlayer.on(Events.USER_INACTIVE, function (videoPlayer) {
        isMobileDevice() &&
          !this.videoPlayer.paused() &&
          toggleFreeMinutes(true);
      });

      this.videoPlayer.on(Events.TIME_UPDATE, function (videoPlayer) {
        if (!that.isAdPlaying) {
          const companionAdContainer = document.querySelector('.adContainer');
          if (companionAdContainer) {
            companionAdContainer.style.display = 'none';
          }
          const companionAd = document.querySelector('.companionAdATF');
          if (companionAd) {
            companionAd.classList.remove('companionAdBanner');
          }
        }
        if (document.querySelector('.drowerPopupContent')) {
          that.playerConfig.hideSubscriptionNudge();
        }
        if (timeUpdateConviFlag) {
          timeUpdateConviFlag = false;
        }
        onTimeUpdateEventHelper(videoPlayer);

        // SOShandler(
        //   videoPlayer,
        //   that.sosAssetType,
        //   that.sosAssetSubtype,
        //   that.sosCapping
        // );
        if (document.querySelector('.vjs-menu-button')) {
          that?.videoPlayer?.videoPlayer?.controlBar
            ?.getChild('SourceMenuButton')
            ?.controlText('Quality selector');
        }
        let playableData = that.playableData;
        let playerCurrentTime = 0;
        try {
          playerCurrentTime = videoPlayer.currentTime();
        } catch (error) {
          console.log('player current time get error');
        }
        //Content Descriptors
        if (
          playerCurrentTime > 4 &&
          that.contentDescriptorHidden &&
          !that.isAdPlaying
          // commenting for NOC-12846
          // &&
          // playableData.asset_subtype !== 'trailer' &&
          // playableData.asset_subtype !== 'promo'
        ) {
          that.contentDescriptorHidden = false;
          showContentDescriptor(that.playerConfig);
        }
        if (window.navigator && !window.navigator.onLine) {
          that.playerConfig.triggerPopUp({
            name: 'networkRetry',
            playerErrorCode: getFormattedErrorCode(ErrorCode.NETWORK)
          });
          videoPlayer.pause();
          if (window.navigator && window.navigator.connection) {
            window.navigator.connection.onchange = () => {
              if (
                window.navigator &&
                window.navigator.onLine &&
                document.querySelector('.main-container')
              ) {
                document.querySelector('.main-container').remove();
                videoPlayer.play();
              }
            };
          } else {
            let triggerNetworkTimer = setInterval(function () {
              if (
                window.navigator &&
                window.navigator.onLine &&
                document.querySelector('.main-container')
              ) {
                document.querySelector('.main-container').remove();
                videoPlayer.play();
                clearInterval(triggerNetworkTimer);
              }
            }, 100);
          }
        }
        // add go live first time
        if (that.isSportsLive && videoPlayer.liveTracker.isLive()) {
          if (
            videoPlayer.liveTracker.behindLiveEdge() &&
            document.getElementsByClassName('go-live-button').length === 0
          ) {
            addGoLiveButton(videoPlayer, () => {
              videoPlayer.liveTracker.seekToLiveEdge();
            });
          } // toggle below
          else if (
            !videoPlayer.liveTracker.behindLiveEdge() &&
            !(document.getElementsByClassName('go-live-button').length === 0)
          ) {
            const goLiveButtonContainer =
              document.querySelector('.go-live-button');
            if (goLiveButtonContainer) {
              goLiveButtonContainer.style.display = 'none';
            }
          } else if (
            videoPlayer.liveTracker.behindLiveEdge() &&
            !(document.getElementsByClassName('go-live-button').length === 0)
          ) {
            const goLiveButtonContainer =
              document.querySelector('.go-live-button');
            if (goLiveButtonContainer) {
              goLiveButtonContainer.style.display = 'block';
            }
          }
        }
      });

      this.videoPlayer.on(Events.META_DATA_LOADED, function (videoPlayer: any) {
        const { entitlement } = that.singlePlayDetails || {};
        const { isLive } = entitlement;
        if (!isLive) {
          const liveButtonContainer =
            document.querySelector('.vjs-live-control');
          if (liveButtonContainer) {
            liveButtonContainer.style.display = 'none';
          }
        } else {
          const liveButtonContainer =
            document.querySelector('.vjs-live-control');
          if (liveButtonContainer) {
            liveButtonContainer.style.display = 'flex';
          }
        }
        const multiAudioConfig = that.playerConfig?.getFeatureFlagConfig(
          FeatureFlagConstant.MULTI_AUDIO
        );
        npawAnaltics.getPlugin()?.setVideoOptions({
          [VIDEO_OPTIONS_KEYS.SUBTITLES]: getSubtitles()
        });
        npawAnaltics.getPlugin()?.setVideoOptions({
          [VIDEO_OPTIONS_KEYS.RENDITION]: getRendition()
        });
        const multiAudioSelectionEnabled = multiAudioConfig?.enabled ?? false;

        // START - Logic for handling default audio selection for multi-audio assets
        if (multiAudioSelectionEnabled) {
          const { assetDetails } = that.singlePlayDetails;
          const { ordered_audio_languages = [], entitled_languages = [] } =
            assetDetails;
          const defaultAudioLang = selectDefaultAudioLanguage(
            ordered_audio_languages,
            entitled_languages
          );
          setDefaultAudioTrack(videoPlayer, defaultAudioLang);
        }
        // END - Logic for handling default audio selection for multi-audio assets

        if (
          multiAudioSelectionEnabled &&
          getBrowserType() !== 'Safari' &&
          !that.isAdPlaying &&
          !that.isSportsLive
        ) {
          createLanguageSelectionPills(videoPlayer, multiAudioConfig, that);
        }
        adCuePoints(that.playerConfig, videoPlayer, that.singlePlayDetails);
        const featureGatingConfig = that.playerConfig?.getFeatureFlagConfig(
          FeatureFlagConstant.FEATURE_GATING
        );
        const { enabled: isPlayerLogoEnabled, payload: logoPayload } =
          that.playerConfig?.getFeatureFlagConfig(
            FeatureFlagConstant.CONFIG_PLAYER_LOGO
          );
        this.languageLogoPayload = logoPayload;
        this.isPlayerLogoEnabled = isPlayerLogoEnabled;

        that.initGatingTimer = featureGatingConfig?.enabled ?? false;
        const freeEpisodeCount =
          featureGatingConfig?.payload?.free_episode_count ?? 1;
        if (that.initGatingTimer) {
          that.initGatingTimer = false;
          initGatingTimer(that, freeEpisodeCount);
        }
        // Sports-live content renders its own audio selection unit instead of
        // the VOD pills, and only when no prefferedAudioStream is stored.
        if (that.isSportsLive && !getLocalStorage('prefferedAudioStream')) {
          createLanguageSelectionUnit(videoPlayer);
        }
        // moved audiotrachLabel fn call here
        if (that.entitledLanguages?.length > 0) {
          that.entitledLanguages = [
            ...that.entitledLanguages,
            ...supportForOlderContents
          ];
        }
        console.log('Entitled languages:', that.entitledLanguages);
        const { audioLanguageMapper } = that.playerConfig;
        // Sports-live only: manifests carry a single audio track, so pass the
        // singlePlay audio_languages + stream_language to inject dummy tracks.
        // VOD keeps the original empty-object args (no behaviour change).
        const sportsLiveAudioLanguages = that.isSportsLive
          ? that.singlePlayDetails?.assetDetails?.ordered_audio_languages
              ?.length
            ? that.singlePlayDetails.assetDetails.ordered_audio_languages
            : that.singlePlayDetails?.assetDetails?.audio_languages || []
          : {};
        const sportsLiveStreamLanguage = that.isSportsLive
          ? that.singlePlayDetails?.keyOsDetails?.stream_language
          : {};

        that.videoPlayer.modifyAudioTracksLabel(
          sportsLiveAudioLanguages,
          sportsLiveStreamLanguage,
          that.entitledLanguages,
          isEntitledLanguageFeatureEnabled,
          multiAudioSelectionEnabled,
          audioLanguageMapper,
          that.isSportsLive
        );
        if (isEntitledLanguageFeatureEnabled && multiAudioSelectionEnabled) {
          modifyLanguageChangeMenu(videoPlayer, that);
        }
        if (this.isPlayerLogoEnabled && this.languageLogoPayload) {
          addLanguageLogo(
            videoPlayer,
            this.languageLogoPayload,
            that.singlePlayDetails
          );
        }
        let singlePlayDetails = that.singlePlayDetails;
        if (
          !that.metaDataLoaded &&
          singlePlayDetails &&
          singlePlayDetails.assetDetails &&
          singlePlayDetails.assetDetails.subtitle_url &&
          singlePlayDetails.assetDetails.subtitle_url.length > 0
        ) {
          let activeLanguageTrack = that.videoPlayer.getActiveLanguageTrack();
          let textTracks = that.generateSubtitleTracks(
            singlePlayDetails.assetDetails.subtitle_url,
            activeLanguageTrack
          );
          if (textTracks.length > 0) that.videoPlayer.addTextTracks(textTracks);
        }
        const getCurrentTime = that.getContentCurrentTime();
        that.videoPlayer.videoPlayer.currentTime(getCurrentTime);
        that.metaDataLoaded = true;
        // VTT thumbnails implementation
        // plugin function is imported by importing the module 'videojs-vtt-thumbnails'
        // this is attached to videoplayer
        // source path is passed
        let srcVtt =
          that.playerConfig.singlePlayDetails.assetDetails.vtt_thumbnail_url ||
          '';
        that.videoPlayer.setVttThumbnailSrc(srcVtt);
        let spapirequestTimeStamp =
          that.createSpapiRequestTimeStampPayload(singlePlayDetails);
        that.sendConvivaReportEvent(spapirequestTimeStamp);
        let spapiResponseTimeStamp =
          that.createSpapiResponsetTimeStampPayload(singlePlayDetails);
        that.sendConvivaReportEvent(spapiResponseTimeStamp);
      });

      this.videoPlayer.on(Events.SEEKED, (videoPlayer: any, seekDetails) => {
        if (window['isCastConnected']) {
          window['seekingSenderBar'] = true;
          seekReceiverWithSeekedSender(videoPlayer);
        }
        onSeekSrubEventHelper(seekDetails);
      });

      this.videoPlayer.on(Events.VOLUME_CHANGE, (videoPlayer: any) => {
        onVolumeChange(videoPlayer);
        if (window['isCastConnected']) {
          setReceiverVolume(videoPlayer);
        }
      });

      this.videoPlayer.on(Events.PLAYING, (videoPlayer: any) => {

        // Reporting video view event when first frame renders to prevent triggering on EBVS or VSF (COR-31918)
        reportVideoViewEvent(that.singlePlayDetails.assetDetails.id);
        const title = this.singlePlayDetails?.assetDetails?.tvshow_name ||
            this.singlePlayDetails?.assetDetails?.title || this.singlePlayDetails?.assetDetails?.original_title
        const assetTypeValue = this.singlePlayDetails?.assetDetails?.asset_subtype || '';
        const assetType = assetTypeValue.charAt(0).toUpperCase() + assetTypeValue.slice(1);
        const genres = this.singlePlayDetails?.assetDetails?.genres || [];
        const genreIds = genres?.map((g: any) => g.id);
        const metadataCategories =
          assetTypeValue === 'live_event' || assetTypeValue === 'sports_vod'
            ? genreIds
            : [assetType, ...genreIds];

        this.videoPlayer.setMetadata(title, metadataCategories);
        const { reportGA4Event } = that.playerConfig;
        if (reportGA4Event) {
          const payload = {
            eventName: 'Content_View_AVOD',
            trackObject: {}
          };
          reportGA4Event(payload);
        }
      });

      this.videoPlayer.on(Events.READY, function (videoPlayer: any) {
        displayScoreCard(that.playerConfig);
        detectChromeCast();
        const { enabled, payload } = that.playerConfig.getFeatureFlagConfig(
          'config_player_reload'
        );
        if (that.isPopUpVideo) {
          registerEvents(that, that.isPopUpVideo);
          convivaSessionKeyMomentsOnReady(videoPlayer);
        } else {
          window.enableReloadPlayerOnTimeout = enabled
            ? payload['ENABLEPLAYERRELOADTIMER'] || false
            : false;

          if (window.enableReloadPlayerOnTimeout) {
            (function pageReloader() {
              window.playerSeconds = 0;
              window.clearPlayerReloadTimer = that.clearPlayerReloadTimer;

              const reloadPlayerTimeoutInSecs = payload['PLAYERSECONDS'] || 30;
              const reloadPlayerRetryCount = payload['RELOADCOUNT'] || 2;

              that.incrementPlayerCounter = () => {
                if (
                  window.playerSeconds > reloadPlayerTimeoutInSecs &&
                  window.isPlayingEventSent === false &&
                  document.getElementById('video-tag-tobaccoAdvisory') === null
                ) {
                  if (that.reloadCount < reloadPlayerRetryCount) {
                    that.reloadCount += 1;
                    that.reloadPlayer();
                  }
                }
                if (
                  that.reloadCount < reloadPlayerRetryCount &&
                  that.isAdPlaying === false
                ) {
                  window.playerSeconds = window.playerSeconds + 1;
                  window.playerReloadTimer = setTimeout(
                    that.incrementPlayerCounter,
                    1000
                  );
                }
              };
              that.incrementPlayerCounter();
            })();
            // pageReloader();
          }
          convivaSessionOnReady(videoPlayer);
        }
        if (
          that.playerConfig.callConsumptionPageApis &&
          !that.validContentTypesForStaleApi.includes(
            that.playerConfig.contentType
          )
        ) {
          that.playerConfig.callConsumptionPageApis();
        }
      });
      // time between Ready and Play is the VST
      this.videoPlayer.on(Events.PLAY, function (videoPlayer) {
        const { reportGA4Event } = that.playerConfig;
        if (
          !that.isAdPlaying &&
          reportGA4Event &&
          !that.isLongWatchEventSent &&
          !that.triggerGA4timeout &&
          that.longWatchRemainingTime > 0
        ) {
          const payloadLongWatch = {
            eventName: 'Content_View_AVOD_Web_5mins',
            trackObject: {}
          };
          that.longWatchStartTime = Date.now();
          that.triggerGA4timeout = setTimeout(() => {
            reportGA4Event(payloadLongWatch);
            that.isLongWatchEventSent = true;
            that.triggerGA4timeout = null;
          }, that.longWatchRemainingTime);
        }
        if (
          that.showTobaccoAdvisoryWithoutPreRoll &&
          !that.preRollTobaccoAdvisoryVideoShown &&
          that.hasTobaccoAdvisoryVideo
        ) {
          that.showTobaccoAdvisoryWithoutPreRoll = false;
          that.preRollTobaccoAdvisoryVideoShown = true;
          showTobaccoAdvisoryPreRollVideo();
        }
        if (document.querySelector('.drowerPopupContent')) {
          that.playerConfig.hideSubscriptionNudge();
        }
        if (localStorage.getItem('resumeLiveStream') === 'true') {
          registerEvents(that);
          localStorage.removeItem('resumeLiveStream');
          window.convivaAnalytic?.reportEvent(
            window.Conviva?.Constants.Events.USER_WAIT_ENDED || ''
          );
          // convivaSessionOnReady(videoPlayer);
        }

        const { payload: offersDataForSports } =
              that.playerConfig?.getFeatureFlagConfig(
                FeatureFlagConstant.CONFIG_SPORTS
              ) || {};

        const userWaterMarkConfig = offersDataForSports?.config_user_detection_via_watermark || {};
        if(userWaterMarkConfig?.enable_user_watermark && isLiveFIFAEvent(that.singlePlayDetails) && isB2BPartner()) {
            // Apply user-identification watermark when enabled via remote config.
            addUserWaterMark(videoPlayer, userWaterMarkConfig);
        }
        // x free minutes handling
        if (that.isSportsLive) {
          toggleKeyMoments(true);
          let waterMark = document.querySelector('.watermarkContainer');
          waterMark ? (waterMark.style.display = 'block') : '';
          if (that.playerConfig.userType !== 'premium') {
            // setting freeAvailableSeconds to default from config
            if (
              that.playerConfig &&
              that.playerConfig.xmins_free_config &&
              that.playerConfig.xmins_free_config.live_event &&
              that.playerConfig.xmins_free_config.live_event.free_period_in_mins
            ) {
              that.freeAvailableSeconds =
                parseInt(
                  that.playerConfig.xmins_free_config.live_event
                    .free_period_in_mins
                ) * 60;
              that.showFreeMinutesTimer = true;
            } else {
              that.showFreeMinutesTimer = false;
              // that.freeMinutesTimer = {};
            }

            // update freeAvailableSeconds if available in local storage
            let frMinsFromStorage = getFreeMinutes(that.playerConfig.contentId);
            if (frMinsFromStorage) {
              that.freeAvailableSeconds = getFreeMinutes(
                that.playerConfig.contentId
              );
            } else if (frMinsFromStorage === 0) {
              that.freeAvailableSeconds = getFreeMinutes(
                that.playerConfig.contentId
              );
            }

            that.checkFreeMinutesPopup();

            // timer for calculating free minutes available
            const freeMinutesInfoContainer = document.querySelector(
              '.freeMinutesInfoTimer'
            );
            if (
              that.showFreeMinutesTimer &&
              !freeMinutesInfoContainer &&
              that.freeAvailableSeconds > 0
            ) {
              that.playerConfig.showFreeMinutes({
                playerRef: that,
                timeRemaining: that.freeAvailableSeconds
              });
            }

            // timer for calculating free minutes available
            if (!that.freeMinutesTimer && that.showFreeMinutesTimer) {
              that.freeMinutesTimer = setInterval(() => {
                that.freeAvailableSeconds = that.freeAvailableSeconds - 1;
                //free minutes ended for user
                that.checkFreeMinutesPopup();
                setFreeMinutes(
                  that.playerConfig.contentId,
                  that.freeAvailableSeconds
                );
                updateFreeMinutes(that.freeAvailableSeconds);
              }, 1000);
            }
          }
          // free minutes ends

          // watermark related handling
          let watermarkContainer = document.querySelector(
            '.watermarkContainer'
          );
          if (!watermarkContainer) {
            const { payload: offersDataForSports } =
              that.playerConfig?.getFeatureFlagConfig(
                FeatureFlagConstant.CONFIG_SPORTS
              ) || {};
            let concurrentTimer = 30;

            if (offersDataForSports?.concurrent_users_interval) {
              concurrentTimer = offersDataForSports.concurrent_users_interval;
            } else {
              concurrentTimer = 30;
            }

            const userWaterMarkConfig = offersDataForSports?.config_user_detection_via_watermark || {};

            if (userWaterMarkConfig?.enable_user_watermark) {
              // Apply user-identification watermark when enabled via remote config.
              addUserWaterMark(videoPlayer, userWaterMarkConfig);
            }
            addWaterMark(videoPlayer);
            if (!that.concurrentUsersTimer) {
              fetchConcurrentUsers(that.playableData, that.playerConfig);
              that.concurrentUsersTimer = setTimeout(function myTimer() {
                fetchConcurrentUsers(that.playableData, that.playerConfig);
                that.concurrentUsersTimer = setTimeout(
                  myTimer,
                  concurrentTimer * 1000
                );
              }, concurrentTimer * 1000);
            }
          }
          // watermark handling ends
          // remove live edge button only for sports live
          const seekLiveControlContainer = document.querySelector(
            '.vjs-seek-to-live-control'
          );
          if (seekLiveControlContainer) {
            seekLiveControlContainer.style.display = 'none';
          }
        }

        const { entitlement } = that.singlePlayDetails || {};
        const { isLive } = entitlement;
        if (isLive) {
          const timeDivider = document.querySelector('.vjs-time-divider');
          if (timeDivider) {
            timeDivider.style.display = 'none';
          }
          const DurationDisplayTimer = document.querySelector('.vjs-duration');
          if (DurationDisplayTimer) {
            DurationDisplayTimer.style.display = 'none';
          }
          const currentTimer = document.querySelector('.vjs-current-time');
          if (currentTimer) {
            currentTimer.style.marginRight = 'auto';
          }
          if (!that.isSportsLive) {
            if (currentTimer) {
              currentTimer.style.display = 'none';
            }
          }
        }

        const isAdStacksDataAvailable =
          that.playerConfig.isAdStacksDataAvailable() || false;
        onPlayEventHelper(
          videoPlayer,
          that.isPopUpVideo,
          isAdStacksDataAvailable
        );

        if (
          that.isNewsCatchup &&
          document.getElementsByClassName('go-live-button').length === 0
        ) {
          addGoLiveButton(videoPlayer, that.playerConfig.goLiveCallback);
        }
        const mandatoryPopupContainer =
          document.querySelector('.main-container');
        if (mandatoryPopupContainer && mandatoryPopupContainer !== null) {
          that.videoPlayer.pause();
        }
        if (
          window.location.href.includes('b2b-consumption') &&
          typeof that.playerConfig.clearSubscriptionNudgePopupTimer ===
          'function'
        ) {
          that.playerConfig.clearSubscriptionNudgePopupTimer();
        }
        that.playerConfig.clearSubscriptionNudgePopupTimer();
      });

      this.videoPlayer.on(Events.PAUSE, function (videoPlayer: any) {
        onPauseEventHelper(videoPlayer);
        if (that.triggerGA4timeout) {
          clearTimeout(that.triggerGA4timeout);
          that.triggerGA4timeout = null;
          if (that.longWatchStartTime > 0 && !that.isLongWatchEventSent) {
            const elapsed = Date.now() - that.longWatchStartTime;
            that.longWatchRemainingTime -= elapsed;
          }
        }
        if (that.isSportsLive) {
          that.clearFreeSecondsTimer();
        }
        if (!this.isStaleApisCalled) {
          setTimeout(() => {
            if (that.playerConfig && that.playerConfig.callStaledApis) {
              that.playerConfig.callStaledApis();
              this.isStaleApisCalled = true;
            }
          }, 3000);
        }
        // Local Storage used for storing number of count and expiry time
        if (
          !window.location.href.includes('b2b-consumption') &&
          that.playerConfig.shouldSubscriptionNudgeDisplayed({
            nudgeType: 'popup',
            playerRef: that
          })
        ) {
          const {
            paused_wait_duration: pauseDuration = 10,
            frequency: popupFrequency = 3
          } =
            that.playerConfig.getAvodNudgeConfig(
              that.playerConfig.remoteConfig
            ) || [];
          var AvodNudgeCount: any = getLocalStorage('AvodNudgeCount');
          var expirydte: any = getLocalStorage('AvodNudgeExpDate');
          var AvodSessionCount: any = getSessionStorage('AvodSessionCount');
          let originalDate: any = new Date();
          let now: any = `${originalDate.getFullYear()}${originalDate.getMonth()}${originalDate.getDate()}`;
          if (!AvodNudgeCount) {
            AvodNudgeCount = '0';
            setLocalStorage('AvodNudgeCount', AvodNudgeCount);
            setLocalStorage(
              'AvodNudgeExpDate',
              `${originalDate.getFullYear()}${originalDate.getMonth()}${originalDate.getDate()}`
            );
          }
          if (!AvodSessionCount) {
            AvodSessionCount = '0';
            setSessionStorage('AvodSessionCount', '0');
          }
          if (
            parseInt(AvodNudgeCount) > 0 &&
            parseInt(now) != parseInt(expirydte)
          ) {
            AvodNudgeCount = '0';
            setLocalStorage('AvodNudgeCount', AvodNudgeCount);
            setLocalStorage(
              'AvodNudgeExpDate',
              `${originalDate.getFullYear()}${originalDate.getMonth()}${originalDate.getDate()}`
            );
          }
          if (
            parseInt(AvodNudgeCount) < popupFrequency &&
            parseInt(AvodSessionCount) < 1
          ) {
            window.avodNudgeHandler = setTimeout(() => {
              if (
                !document.querySelector('#main-container') &&
                !document.querySelector('.subscriptionPopupCompWrap') &&
                !document.querySelector('.drowerPopupContent') &&
                !that.isAdPlaying &&
                window?.videoPlayer?.paused()
              ) {
                that.playerConfig.showSubscriptionNudge(
                  videoPlayer,
                  that.playerConfig
                );
                setLocalStorage(
                  'AvodNudgeCount',
                  `${parseInt(AvodNudgeCount) + 1}`
                );
                setSessionStorage(
                  'AvodSessionCount',
                  `${parseInt(AvodSessionCount) + 1}`
                );
              }
            }, pauseDuration * 1000);
          }
        }
      });
      this.videoPlayer.on(Events.ENDED, function (videoPlayer) {
        if (that.isPopUpVideo && that.playerConfig.closeKeyMomentsPopup) {
          that.dispose();
          that.playerConfig.closeKeyMomentsPopup();
          convivaAnalyticsTracker.reportPlaybackEndedConviva();
        } else {
          onPlayEndedEventHelper(videoPlayer);
        }
      });

      this.videoPlayer.on(Events.FULL_SCREEN_CHANGE, function (event) {
        npawAnaltics
          .getPlugin()
          ?.getAdapter()
          ?.fireEvent('fullScreen', {
            isFullScreen: that.videoPlayer.videoPlayer.isFullscreen()
          });
        that.playerConfig.triggerForCommerceLandscape();
        fullScreenEvent(that.videoPlayer.videoPlayer);
        return that.playerConfig.checkIsFullScreen();
      });

      this.videoPlayer.on(Events.SKIPINTRO, function (videoPlayer) {
        console.log('Skip Intro');
      });

      this.videoPlayer.on(
        'audioChanged',
        function (
          videoPlayer: any,
          audioLanguage: any,
          audioLanguageMapper: any
        ) {
          npawAnaltics.getPlugin()?.setVideoOptions({
            [VIDEO_OPTIONS_KEYS.LANGUAGE]:
              audioLanguageMapper[audioLanguage.toLowerCase()] ||
              getLanguageName(audioLanguage) ||
              NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE
          });
          audioChange(
            audioLanguage,
            that.isSportsLive,
            '',
            that.singlePlayDetails
          );
          // SubtitlePreference when browser is not Safari
          if (this.isPlayerLogoEnabled && this.languageLogoPayload) {
            updateLanguageLogo(audioLanguage, this.languageLogoPayload);
          }
          if (getBrowserType() !== 'Safari') {
            let activeLanguageTrack = that.videoPlayer.getActiveLanguageTrack();
            let textTracks = that.generateSubtitleTracks(
              that.singlePlayDetails.assetDetails.subtitle_url,
              activeLanguageTrack
            );
            if (textTracks.length > 0) {
              that.videoPlayer.applySubtitleChangesOnAudioChange(
                textTracks,
                audioLanguage
              );
            }
          }
        }
      );

      this.videoPlayer.on(Events.QUALITY_CHANGE, function (selectedQuality) {
        videoQualityChange(selectedQuality);
      });

      this.videoPlayer.on(Events.SUBTITLECHANGE, function (videoPlayer) {
        var issubtitleOn =
          Object.keys(
            videoPlayer
              .textTracks()
              .tracks_.filter((subs) => subs.mode === 'showing')
          ).length > 0
            ? 'On'
            : 'Off';
        subtitleChange(playerEventsConstants.subTitleChange, issubtitleOn);
        let label = getActiveSubtitles(videoPlayer);
        let adContainer = document.getElementById('video-tag_ima-ad-container');
        if (adContainer && adContainer.style.display === 'block') {
          return;
        } else {
          if (getBrowserType() !== 'Safari') {
            let activeLanguageTrack = that.videoPlayer.getActiveLanguageTrack();
            let subtitlePreference =
              localStorage.getItem('subtitlePreference') || {};
            // sessionStorage.setItem('subtitleName', label);
            if (activeLanguageTrack) {
              if (typeof subtitlePreference === 'string') {
                subtitlePreference = JSON.parse(subtitlePreference);
              }
              subtitlePreference[activeLanguageTrack] = label;
              setLocalStorage('subtitlePreference', subtitlePreference);
            }
          } else {
            sessionStorage.setItem('subtitleName', label);
          }
          npawAnaltics.getPlugin()?.setVideoOptions({
            [VIDEO_OPTIONS_KEYS.SUBTITLES]:
              label || NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE
          });
          if (window['isCastConnected']) {
            textTracksChange(label, that);
          }
        }
      });

      this.videoPlayer.on(Events.PROGRESS, function (videoPlayer) {
        if (videoPlayer.currentTime() > 0) {
          that.firstPlay = true;
        }
        playerProgress(videoPlayer);
        if (!that.isPopUpVideo) {
          triggerWatchHistory(videoPlayer);
          handleStaleApiCall(videoPlayer);
        }
      });

      this.videoPlayer.on(Events.ERROR, function (error) {
        fetchSelfErrors(that.playerConfig);
        if (that.playerConfig && that.playerConfig.callStaledApis) {
          that.playerConfig.callStaledApis();
        }
        let { code: errorCode = 'N/A', message: errorMessage = 'N/A' } = error;
        if (
          errorCode.toString() ===
          ErrorCode.MEDIA_ERR_SRC_NOT_SUPPORTED.toString()
        ) {
          errorMessage = 'MEDIA_ERR_SRC_NOT_SUPPORTED';
        } else if (errorCode.toString() === ErrorCode.TIMEOUT.toString()) {
          errorMessage = 'TIMEOUT';
        } else if (
          errorCode.toString() === ErrorCode.UNSUPPORTED_SCHEME.toString()
        ) {
          errorMessage = 'UNSUPPORTED_SCHEME';
        } else if (
          errorCode.toString() === ErrorCode.BAD_HTTP_STATUS.toString()
        ) {
          errorMessage = 'BAD_HTTP_STATUS';
        } else if (errorCode.toString() === ErrorCode.HTTP_ERROR.toString()) {
          errorMessage = 'HTTP_ERROR';
        } else if (errorCode.toString() === ErrorCode.NETWORK.toString()) {
          errorMessage = 'NETWORK';
        }
        if (!that.isPlayingClearContent) {
          convivaAnalyticsTracker.updateConvivaInfo({
            infoMessage: JSON.stringify({
              errorCode: `${errorCode}`,
              errorMessage: `${errorMessage}`
            })
          });
          convivaAnalyticsTracker.convivaSessionWaitStarted();
          let clearMedia = that.getClearMedia();
          if (clearMedia) {
            that.initializeFallbackPlayback();
          } else {
            onErrorHelper(error, videoPlayer, that.playerConfig);
          }
          if (window) {
            window.drmSessionError = true;
          }
        } else {
          onErrorHelper(error, videoPlayer, that.playerConfig);
        }
        if (
          that.playerConfig.callConsumptionPageApis &&
          !that.validContentTypesForStaleApi.includes(
            that.playerConfig.contentType
          )
        ) {
          that.playerConfig.callConsumptionPageApis();
        }
      });

      this.videoPlayer.on(Events.DISPOSE, function (error) {
        if (this.triggerGA4timeout) {
          clearTimeout(this.triggerGA4timeout);
          this.triggerGA4timeout = null;
        }
      });

      let displayAd = false;

      this.videoPlayer.on(AdEvents.AD_STARTED, function () {
        const scoreMainContainer = document.querySelector(
          '.scoreMainContainer'
        ) as HTMLElement | null;
        if (scoreMainContainer) {
          if (scoreMainContainer.style.display === 'none') {
            displayAd = false;
          } else if (scoreMainContainer.style.display === 'flex') {
            scoreMainContainer.style.display = 'none';
            displayAd = true;
          }
        }
        // Check for Safari and show zee-ad-container if it's hidden
        const browserType = getBrowserType();
        if (browserType === 'Safari') {
          const zeeAdContainer = document.querySelector("#zee-ad-container") as HTMLElement;
          if (zeeAdContainer && zeeAdContainer.style.display === 'none') {
            zeeAdContainer.style.display = 'block';
          }
        }
        if (that.triggerGA4timeout) {
          clearTimeout(that.triggerGA4timeout);
          that.triggerGA4timeout = null;
          if (that.longWatchStartTime > 0 && !that.isLongWatchEventSent) {
            const elapsed = Date.now() - that.longWatchStartTime;
            that.longWatchRemainingTime -= elapsed;
          }
        }
        // const companionAdContainer = document.querySelector('.adContainer');
        // if (companionAdContainer) {
        //   companionAdContainer.style.display = 'block';
        // }

        that.isAdPlaying = true;
        that.playerConfig.updateAdStatusCallback(true);
        if (window && window.chromePopupDisplayed) {
          that.videoPlayer.pause();
        }
        if (that.isSportsLive) {
          toggleKeyMoments(false);
          let waterMark = document.querySelector('.watermarkContainer');
          waterMark ? (waterMark.style.display = 'none') : '';
        }
        showIsTrailer(false);
        toggleSubscribeTeaserBanner(false);
      });

      this.videoPlayer.on(AdEvents.AD_COMPLETE, function (videoPlayer) {

        const scoreMainContainer = document.querySelector(
          '.scoreMainContainer'
        ) as HTMLElement | null;
        if (scoreMainContainer) {
          if (displayAd === true) {
            scoreMainContainer.style.display = 'flex';
            displayAd = false;
          }
        }
        that.isAdPlaying = false;
        if (
          that.hasTobaccoAdvisoryVideo &&
          !that.preRollTobaccoAdvisoryVideoShown
        ) {
          that.preRollTobaccoAdvisoryVideoShown = true;
          showTobaccoAdvisoryPreRollVideo();
        }
        that.playerConfig.updateAdStatusCallback(false);
        if (that.isSportsLive) {
          toggleKeyMoments(true);
          let waterMark = document.querySelector('.watermarkContainer');
          waterMark ? (waterMark.style.display = 'block') : '';
        }
        let companionAd: any;
        if (isMobileDevice()) {
          companionAd = document.querySelector('.adContainer');
        } else {
          companionAd = document.querySelector('.companionAdATF');
        }
        if (companionAd) {
          companionAd.style.display = 'none';
        }
        showIsTrailer(true);
        const continueWatch = document.getElementById('continue-div');
        if (continueWatch) {
          toggleSubscribeTeaserBanner(false);
        } else {
          toggleSubscribeTeaserBanner(true);
        }
      });

      this.videoPlayer.on(AdEvents.PRE_ROLL_COMPLETED, function (videoPlayer) {

        that.isAdPlaying = false;

        if (that.hasAdError) {
          const browserType = getBrowserType();
          if (browserType === 'Safari') {
             const zeeAdContainer = document.querySelector("#zee-ad-container") as HTMLElement;
             if (zeeAdContainer){
               zeeAdContainer.style.display = "none";
             }
          }
          that.hasAdError = false;
        }

        const multiAudioConfig = that.playerConfig?.getFeatureFlagConfig(
          FeatureFlagConstant.MULTI_AUDIO
        );
        const multiAudioSelectionEnabled = multiAudioConfig?.enabled ?? false;
        if (
          multiAudioSelectionEnabled &&
          getBrowserType() !== 'Safari' &&
          !that.isAdPlaying &&
          !that.isSportsLive
        ) {
          createLanguageSelectionPills(videoPlayer, multiAudioConfig, that);
        }
        if (
          !that.mandatoryVideoCountUpdated &&
          !that.getMandatoryPopupStatus()
        ) {
          if (that.videoPlayer.pause) that.videoPlayer.pause();
          that.playerConfig.triggerPopUp({ name: 'mandatoryRegistration' });
        } else if (that.checkToTriggerSubscriptionNudge()) {
          that.triggerSubscriptionNudge();
        } else if (
          that.hasTobaccoAdvisoryVideo &&
          !that.preRollTobaccoAdvisoryVideoShown
        ) {
          that.preRollTobaccoAdvisoryVideoShown = true;
          showTobaccoAdvisoryPreRollVideo();
        }
        if (
          that.preRollForDaiConfig &&
          that.videoPlayer &&
          that.videoPlayer.destroy
        ) {
          window.drmSessionError = true;
          that.initializePlaybackType();
        }
        that.preRollDetectedorFailed = true;
      });

      this.videoPlayer.on(
        AdEvents.AD_BLOCKER_DETECTED,
        function (videoPlayer: any) {
          that.isAdPlaying = false;
          if (
            !that.mandatoryVideoCountUpdated &&
            !that.getMandatoryPopupStatus()
          ) {
            if (that.videoPlayer.pause) that.videoPlayer.pause();
            that.playerConfig.triggerPopUp({ name: 'mandatoryRegistration' });
          } else if (that.checkToTriggerSubscriptionNudge()) {
            that.triggerSubscriptionNudge();
          } else if (
            that.hasTobaccoAdvisoryVideo &&
            !that.preRollTobaccoAdvisoryVideoShown
          ) {
            that.preRollTobaccoAdvisoryVideoShown = true;
            showTobaccoAdvisoryPreRollVideo();
          }
          that.preRollDetectedorFailed = true;
        }
      );

      this.videoPlayer.on(
        AdEvents.AD_ERROR,
        function (adError: { code: number }) {

          that.hasAdError = true;
          that.isAdPlaying = false;
          if (
            document.querySelector('.video-js') &&
            document
              .querySelector('.video-js')
              .classList.contains('vjs-ad-loading')
          ) {
            document
              .querySelector('.video-js')
              .classList.remove('vjs-ad-loading');
          }
          if (!that.mandatoryVideoCountUpdated && adError.code === 9000) {
            if (!that.getMandatoryPopupStatus()) {
              if (that.videoPlayer.pause) that.videoPlayer.pause();
              that.playerConfig.triggerPopUp({ name: 'mandatoryRegistration' });
            } else if (that.checkToTriggerSubscriptionNudge()) {
              that.triggerSubscriptionNudge();
            } else if (
              that.hasTobaccoAdvisoryVideo &&
              !that.preRollTobaccoAdvisoryVideoShown
            ) {
              that.preRollTobaccoAdvisoryVideoShown = true;
              showTobaccoAdvisoryPreRollVideo();
            }
            that.preRollDetectedorFailed = true;
          }
          let companionAd: any;
          if (isMobileDevice()) {
            companionAd = document.querySelector('.adContainer');
          } else {
            companionAd = document.querySelector('.companionAdATF');
          }
          if (companionAd) {
            companionAd.style.display = 'none';
          }
          if (window.isLive) {
            if (
              that.preRollForDaiConfig &&
              that.videoPlayer &&
              that.videoPlayer.destroy
            ) {
              that.videoPlayer.destroy();
              that.initializePlaybackType();
            }
          }
        }
      );

      this.videoPlayer.on(AdEvents.SKIPPED, function () {
        that.isAdPlaying = false;
        if (
          that.hasTobaccoAdvisoryVideo &&
          !that.preRollTobaccoAdvisoryVideoShown
        ) {
          that.preRollTobaccoAdvisoryVideoShown = true;
          showTobaccoAdvisoryPreRollVideo();
        }
      });

      this.videoPlayer.on(playerEventsConstants.qualityBtnClicked, () => {
        this.analyticsManager.reportEvent(playerEventsConstants.playerCtas, {});
      });

      this.videoPlayer.on(
        playerEventsConstants.audioBtnClicked,
        (videoPlayer: any) => {
          const eventPayLoad = {
            element: 'Audio Change'
          };
          this.analyticsManager.reportEvent(
            playerEventsConstants.playerCtas,
            eventPayLoad
          );
        }
      );

      this.videoPlayer.on(
        playerEventsConstants.muteBtnClicked,
        (videoPlayer: { muted: () => any }) => {
          onmuteChange(videoPlayer);
          var eventPayLoad = {
            muteValue: videoPlayer.muted()
          };
          this.analyticsManager.reportEvent(
            playerEventsConstants.muteChanged,
            eventPayLoad
          );
        }
      );

      this.videoPlayer.on(
        playerEventsConstants.subtitleBtnClicked,
        (videoPlayer: any) => {
          const eventPayLoad = {
            element: 'Subtitle Change'
          };
          this.analyticsManager.reportEvent(
            playerEventsConstants.playerCtas,
            eventPayLoad
          );
        }
      );
    }
  }

  setRecoDetails(recoData: any[]) {
    this.similarFromReco = recoData;
    // to add reco skip button on popups if reco data is not available initially
    triggerRecoSkipButton();
  }

  async checkRecoData() {
    const {
      fetchNextVideos = null,
      fetchPreviousVideos = null,
      similarFromReco = [],
      userType = ''
    } = { ...this.playerConfig };
    const disableUpnextRecoConfig = this.playerConfig.isFeatureEnabled(
      FeatureFlagConstant.DISABLE_UPNEXT_RECO_API
    );
    if (similarFromReco && similarFromReco.length > 0) {
      this.isRecoPending = false;
      this.setRecoDetails(similarFromReco);
    } else {
      if (
        (fetchNextVideos || fetchPreviousVideos) &&
        this.isRecoPending &&
        this.playableData &&
        !disableUpnextRecoConfig &&
        Object.keys(this.playableData).length &&
        this.singlePlayDetails &&
        Object.keys(this.singlePlayDetails).length
      ) {
        this.isRecoPending = false;
        let getRecommendedData =
          this.playableData &&
            this.playableData.asset_subtype &&
            (this.playableData.asset_subtype.indexOf('episode') >= 0 ||
              this.playableData.asset_subtype === 'sports_vod')
            ? await fetchPreviousVideos({ playerRef: this })
            : await fetchNextVideos({ contentId: this.playableData.id });
        if (getRecommendedData && getRecommendedData.items) {
          this.setRecoDetails(getRecommendedData.items);
        } else if (getRecommendedData && getRecommendedData.error_code) {
          this.isRecoPending = true;
        }
      }
    }
    if (
      this.playableData?.business_type === 'free_downloadable' &&
      this.singlePlayDetails?.showDetails?.business_type ===
      'premium_downloadable' &&
      userType === 'guest'
    ) {
      this.setRecoDetails([]); // DO not show upnext
    }
  }

  private isDisplayLanguageChanged(scriptId: string) {
    const script = document.getElementById(scriptId);
    if (!script) {
      return false;
    }
    const src: any = script.getAttribute('src');
    const previousDisplayLang =
      (src && src.split('locale_')?.[1]?.split('.')?.[0]) || '';
    return previousDisplayLang !== this.displayLanguage;
  }

  // functions called fromm FE
  invokePlayer() {
    this.dispose(); // dispose the player before staring new session
    this.metaDataLoaded = false;
    this.isNewsCatchup = false;
    this.mandatoryVideoCountUpdated = false;
    this.preRollDetectedorFailed = false;
    this.isLongWatchEventSent = false;
    this.longWatchRemainingTime = constants.userLongWatchGA4Trigger;
    const SCRIPT_ID = 'videojs-locale';
    if (
      window.translationsAndConfigs &&
      !this.isDisplayLanguageChanged(SCRIPT_ID)
    ) {
      this.checkMediaStartPlayback();
    } else {
      let script = document.getElementById(SCRIPT_ID);
      const displayLanguage = this.displayLanguage;

      if (!script) {
        script = document.createElement('script');
        script.id = SCRIPT_ID;
        document.head.appendChild(script);
      } else {
        document.head.removeChild(script);
        script = document.createElement('script');
        script.id = SCRIPT_ID;
        document.head.appendChild(script);
      }
      script.addEventListener(
        'load',
        function () {
          this.translationsAndConfigs =
            typeof window !== 'undefined' && window
              ? window.translationsAndConfigs
              : {};

          this.checkMediaStartPlayback();
        }.bind(this)
      );
      const playerUrl = () => {
        let playerUrlscript;
        if (this.playerConfig.playerScriptUrl) {
          playerUrlscript = this.playerConfig?.playerScriptUrl.substring(
            0,
            this.playerConfig?.playerScriptUrl.lastIndexOf('/')
          );
        } else {
          playerUrlscript = `https://playerscript.zee5.com/zee5Videojs/${VERSION}`;
        }
        return playerUrlscript;
      };
      // script.setAttribute('src', `https://playerscript.zee5.com/zee5Videojs/locale/locale_${displayLanguage || "en"}.js`);
      script.setAttribute(
        'src',
        `${playerUrl()}/locale/locale_${displayLanguage || 'en'}.js`
      );
      // uncomment below script to load translation files locally to test only, folder should be added inside public->player->and paste locale folder
      // script.setAttribute('src', `/player/locale/locale_${displayLanguage || "en"}.js`);
    }
  }

  private checkMediaStartPlayback() {
    this.playableData = this.getPlayableData();
    ifAssetIdChanges(this.singlePlayDetails.assetDetails.id);
    this.isSportsLive =
      typeof this.playerConfig?.isSportsLiveEvent === 'function'
        ? this.playerConfig.isSportsLiveEvent({
            assetType: this.playableData?.asset_type,
            assetSubType: this.playableData?.asset_subtype
          })
        : false;
    window.isSportsLive = this.isSportsLive ? true : false;
    if (this.playerConfig.contentId && this.playableData) {
      if (this.videoPlayer && this.videoPlayer.destroy) {
        this.videoPlayer.destroy();
      }
      this.initPlaybackFlow();
      this.contentDescriptorHidden = true;
    }
    this.watchHistoryHandler();
    this.abrHandler();
  }

  setPlayerConfig(newPlayerConfig: ZeePlayerConfig): void {
    this.playableData = null;
    this.playerConfig = {
      ...this.playerConfig,
      ...newPlayerConfig
    };
    this.setDataFromPlayerConfig();
    this.isRecoPending = true;
    this.preRollForDaiConfig = false;
  }

  updateWrapperConfig(newPlayerConfig: ZeePlayerConfig) {
    this.playerConfig = {
      ...this.playerConfig,
      ...newPlayerConfig
    };
    if (
      (this.playableData &&
        Object.keys(this.playableData).length &&
        this.isRecoPending &&
        (this.playableData.asset_type !== 9 ||
          this.playerConfig.userType === 'premium')) ||
      (this.playerConfig &&
        this.playerConfig.similarFromReco &&
        this.playerConfig.similarFromReco.length > 0)
    ) {
      this.checkRecoData();
    }
  }

  dispose() {
    if (typeof this.playerConfig.removeScorecardWidget === 'function') {
      this.playerConfig.removeScorecardWidget();
    }
    if (this.isAdPlaying) {
      this.analyticsManager.reportEvent(playerEventsConstants.userClosedAd, {});
      this.analyticsManager.reportEvent(
        playerEventsConstants.exitBeforeAdStart,
        {}
      );
    }

    if (typeof this.videoPlayer === 'object' && this.videoPlayer !== null) {
      this.videoPlayer.pause();
      this.playerDisposedFlag = true;
      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
      this.deregisterEvents();
      this.videoPlayer.destroy();
      this.isPlayerEventRegistered = false;
    }

    if (
      typeof this.playerConfig.clearSubscriptionNudgePopupTimer === 'function'
    ) {
      this.playerConfig.clearSubscriptionNudgePopupTimer();
    }

    if (this.concurrentUsersTimer) {
      clearTimeout(this.concurrentUsersTimer);
    }

    if (typeof resetPlayerEventsHelperValuesOnDispose === 'function') {
      resetPlayerEventsHelperValuesOnDispose();
    }

    if (this.freeMinutesTimer) {
      this.clearFreeSecondsTimer();
    }
  }

  deregisterEvents() {
    this.videoPlayer.removeAllListeners(Events.TIME_UPDATE);
    this.videoPlayer.removeAllListeners(Events.META_DATA_LOADED);
    this.videoPlayer.removeAllListeners(Events.SEEKED);
    this.videoPlayer.removeAllListeners(Events.VOLUME_CHANGE);
    this.videoPlayer.removeAllListeners(Events.READY);
    this.videoPlayer.removeAllListeners(Events.PLAY);
    this.videoPlayer.removeAllListeners(Events.PAUSE);
    this.videoPlayer.removeAllListeners(Events.MUTE);
    this.videoPlayer.removeAllListeners(Events.ENDED);
    this.videoPlayer.removeAllListeners(Events.FULL_SCREEN_CHANGE);
    this.videoPlayer.removeAllListeners(Events.SKIPINTRO);
    this.videoPlayer.removeAllListeners('audioChanged');
    this.videoPlayer.removeAllListeners(Events.ENTITLED_LANG_ERROR);
    this.videoPlayer.removeAllListeners(Events.QUALITY_CHANGE);
    this.videoPlayer.removeAllListeners(Events.SUBTITLECHANGE);
    this.videoPlayer.removeAllListeners(Events.PROGRESS);
    this.videoPlayer.removeAllListeners(Events.ERROR);
    this.videoPlayer.removeAllListeners(AdEvents.AD_STARTED);
    this.videoPlayer.removeAllListeners(AdEvents.AD_COMPLETE);
    this.videoPlayer.removeAllListeners(AdEvents.AD_ERROR);
    this.videoPlayer.removeAllListeners(AdEvents.PRE_ROLL_COMPLETED);
    this.videoPlayer.removeAllListeners(AdEvents.AD_BLOCKER_DETECTED);
    this.videoPlayer.removeAllListeners(
      playerEventsConstants.qualityBtnClicked
    );
    this.videoPlayer.removeAllListeners(playerEventsConstants.audioBtnClicked);
    this.videoPlayer.removeAllListeners(playerEventsConstants.muteBtnClicked);
    this.videoPlayer.removeAllListeners(
      playerEventsConstants.subtitleBtnClicked
    );
  }

  getMandatoryPopupStatus() {
    const { updateMandatoryRegistrationViewCount = null, userType = 'guest' } =
      this.playerConfig || {};
    const { assetDetails = {} } = this.singlePlayDetails || {};
    const { content_qualify_for_mandatory_reg = false } = assetDetails || {};
    const userTypeFlag = userType === 'guest';
    this.mandatoryVideoCountUpdated = true;
    updateMandatoryRegistrationViewCount({ contentData: assetDetails });
    const { enabled, payload } = this.playerConfig.getFeatureFlagConfig(
      FeatureFlagConstant.CONFIG_REGISTRATION_POPUP
    );

    const registrationPopupConfig = enabled ? payload : {};
    const mandatoryRegistrationVideoCount = getLocalStorageInteger(
      'mandatoryRegistrationVideoCount'
    );
    const isBlock =
      mandatoryRegistrationVideoCount &&
      registrationPopupConfig?.popup_frequency &&
      mandatoryRegistrationVideoCount %
      registrationPopupConfig?.popup_frequency ===
      0;
    const popupCount =
      getLocalStorageInteger('skippableRegistrationPopupCount') || 0;
    const isPartner =
      typeof window !== 'undefined' &&
      window &&
      window.location &&
      (window.location.pathname.includes('b2b-consumption') ||
        window.location.pathname.includes('b2b-live-tv'));
    if (
      content_qualify_for_mandatory_reg === true &&
      isBlock &&
      userTypeFlag &&
      !isPartner &&
      registrationPopupConfig?.max_popup_count &&
      popupCount < registrationPopupConfig?.max_popup_count
    ) {
      setLocalStorage(
        'skippableRegistrationPopupCount',
        (popupCount + 1).toString()
      );
      return false;
    }
    return true;
  }

  watchHistoryHandler() {
    const { contentType = '', userType = '' } = this.playerConfig || {};
    const { watchHistoryDetails } = this.singlePlayDetails || {};
    if (contentType && contentType !== 'livetv' && this.playableData) {
      if (watchHistoryDetails && watchHistoryDetails.played_duration) {
        this.setContentCurrentTime(watchHistoryDetails.played_duration);
      } else {
        this.setContentCurrentTime(0);
      }
    }
  }

  setContentCurrentTime(watchTime: number) {
    if (this.playableData && Object.keys(this.playableData).length) {
      this.playableData.watchTime = watchTime;
    }
  }

  getContentCurrentTime() {
    const { clipOffset = 0, primaryMediaId = '' } = this.playerConfig || {};
    const startOffset = clipOffset ? parseInt(clipOffset, 10) : clipOffset;
    let videoStartTime = 0;
    if (
      this.playableData &&
      Object.keys(this.playableData).length &&
      this.playableData.watchTime
    ) {
      videoStartTime = Math.round(this.playableData.watchTime);
    }
    if (primaryMediaId === '' && startOffset) {
      videoStartTime = startOffset;
    }
    return videoStartTime;
  }

  handleVisibilityChange() {
    if (document['hidden']) {
      console.log('visibility hidden');
      this.isVisible = false;
      if (window && window.Conviva && window.Conviva.Analytics) {
        window.Conviva.Analytics.reportAppBackgrounded();
        window.convivaAnalytic?.reportEvent(
          window.Conviva.Constants.Events.USER_WAIT_STARTED
        );
      }
    } else {
      const { userData, isRequestedByBot } = this.playerConfig;
      console.log('visibility');
      this.isVisible = true;
      if (window && window.Conviva && window.Conviva.Analytics) {
        window.Conviva.Analytics.reportAppForegrounded();
        window.convivaAnalytic?.reportEvent(
          window.Conviva.Constants.Events.USER_WAIT_ENDED
        );
      }
      if (this.setPlayerHaltedFlag) {
        this.setPlayerHaltedFlag = false;
        if (this.videoPlayer && this.isPlayingClearContent) {
          console.log('visibility ss');
          this.videoPlayer.setup(
            this.defaultPlayerConfig,
            this.mediaObject,
            this.singlePlayDetails,
            userData,
            this.mixpanelData,
            isRequestedByBot
          );
        } else {
          setTimeout(() => {
            console.log('reloading for DRM content');
            window.location.reload();
          }, 1000);
        }
      }
    }
  }

  sendConvivaReportEvent(eventPayload: { type: string; payload?: string }) {
    if (
      window &&
      window.convivaAnalytic &&
      window.convivaAnalytic.reportEvent
    ) {
      window.convivaAnalytic.reportEvent('customEvent', eventPayload);
    }
  }
  checkToTriggerSubscriptionNudge() {
    let played_duration = 0;
    if (this.singlePlayDetails && this.singlePlayDetails.watchHistoryDetails) {
      const { watchHistoryDetails = {} } = this.singlePlayDetails || {};
      played_duration = watchHistoryDetails.played_duration
        ? watchHistoryDetails.played_duration
        : 0;
    }
    if (
      this.playerConfig.shouldSubscriptionNudgeDisplayed({
        nudgeType: 'overlay',
        playerRef: this
      }) &&
      !played_duration
    ) {
      return true;
    } else {
      return false;
    }
  }

  triggerSubscriptionNudge() {
    const { duration = 10 } =
      this.playerConfig.getAvodNudgeConfig(this.playerConfig.remoteConfig) ||
      [];
    if (this.videoPlayer.pause) this.videoPlayer.pause();
    subscriptionNudgeOnPlayerPopup(this.videoPlayer, this.playerConfig);
    const continueWatch = document.getElementById('continue-div');
    if (continueWatch) {
      setTimeout(() => {
        toggleSubscribeTeaserBanner(false);
        continueWatch.style = `transition:width ${duration}s linear;width:100%;`;
      }, 100);
      setTimeout(() => {
        removeSubscriptionNudgeOnPlayer(this.videoPlayer, this.playerConfig);
      }, duration * 1000);
    }
  }

  clearPlayerReloadTimer() {
    clearTimeout(window.playerReloadTimer);
    window.playerSeconds = 0;
  }

  reloadPlayer() {
    this.clearPlayerReloadTimer();
    this.dispose();
    this.initPlaybackFlow();
  }
  clearFreeSecondsTimer() {
    clearInterval(this.freeMinutesTimer);
    this.freeMinutesTimer = null;
  }

  checkFreeMinutesPopup() {
    if (this.freeAvailableSeconds <= 0) {
      this.playerConfig.freeMinutesEndedPopup({
        playerRef: this,
        isFullScreenFlag: false,
        playerConfig: this.playerConfig,
        videoPlayer: this.videoPlayer
      });
      if (this.freeMinutesTimer) {
        [this.clearFreeSecondsTimer()];
      }
    }
  }

  createSpapiRequestTimeStampPayload(singlePlayDetails: any) {
    let spapiTimeStamp = {
      time: singlePlayDetails.spapiRequestimeStamp
    };
    let eventPayload = {
      type: 'SPAPI Request',
      payload: JSON.stringify(spapiTimeStamp)
    };
    return eventPayload;
  }

  createSpapiResponsetTimeStampPayload(singlePlayDetails: any) {
    let spapiTimeStamp = {
      time: singlePlayDetails.spapiResponseTimeStamp
    };
    let eventPayload = {
      type: 'SPAPI Response',
      payload: JSON.stringify(spapiTimeStamp)
    };
    return eventPayload;
  }
  updateUpnextApiState(upNextApiState: boolean, isUpNextPending: boolean) {
    updateUpnextState({ upNextApiState, isUpNextPending });
  }

  // SOS ABR implementation starts here..

  /**
   * ABR (Adaptive Bitrate) Handler function.
   * This function checks if SOS (Server-Over-Server) is enabled for ABR capping
   * using the player configuration retrieved from S3, and then initiates the SOS interval.
   */

  abrHandler = () => {
    // Determine if SOS is enabled for ABR capping using player configuration
    // If remoteConfig returns falsy value, default to true

    if (this.playerConfig?.isFeatureEnabled) {
      this.isSOSEnabled = this.playerConfig.isFeatureEnabled(
        FeatureFlagConstant.FEATURE_ABR_CAPPING
      );
    }

    // If SOS is enabled, initiate the SOS interval
    if (this.isSOSEnabled) {
      this.sosInterval();
    }
  };
  /**
   * Function to handle  (SOS) interval.
   * This function fetches system status from a remote URL, extracts the SOS response,
   * applies Adaptive Bitrate (ABR) capping, and schedules the next SOS interval using setTimeout.
   */
  sosInterval = async () => {
    // Default refresh interval in seconds

    let refreshInterval = 60;
    try {
      // Define the URL for fetching system status
      // const url = 'https://stcf-nonprod.zee5.com/dev/frontend/session-control/v1/system-status.json';
      const url = this.playerConfig?.sos_abr_url || '';

      // Fetch system status from the specified URL
      if (url) {
        const response = await fetch(url);
        // Parse the JSON response
        const sosResponse = await response.json();

        // Update refresh interval based on the SOS response, default to 60 seconds if not provided
        refreshInterval = sosResponse.refreshInterval || 60;

        // refreshInterval = 10;
        // Extract ABR capping information from the SOS response
        const abrCapping = { ...sosResponse.abrCapping };
        // Apply ABR capping using the current instance's method
        this.applySOSCapping(abrCapping);
      }
    } catch (error) {
      // Log any errors during the fetch or processing of the SOS response
      console.error(error || {}, { type: 'GET' });
    } finally {
      // Schedule the next SOS interval using setTimeout
      setTimeout(this.sosInterval, refreshInterval * 1000);
    }
  };

  applySOSCapping(abrCapping: any) {
    if (abrCapping) {
      const { asset_type, asset_subtype, capping } = abrCapping;
      SOShandler(window.videoPlayer, asset_type, asset_subtype, capping);
    }
  }
  // SOS ABR implementation ends here..
}
